<template>
  <LayoutDashboard title="Relatório de Notas Fiscais">
    <v-card outlined>
      <v-card-title>NF-e emitidas por período.</v-card-title>
      <v-form class="px-3" ref="formRelatorioNfe">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field
                label="Período Inicial"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioNfe.periodo_inicial"
                :rules="rules.perido_inicial_relatorio_nfe"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Período Final"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioNfe.periodo_final"
                :rules="rules.perido_final_relatorio_nfe"
                outlined
                dense
                append-outer-icon="print"
                @click:append-outer="_gerarRelatorioNfe()"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>
    <v-card outlined class="mt-2">
      <v-card-title>NFC-e emitidas por período.</v-card-title>
      <v-form class="px-3" ref="formRelatorioNfce">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field
                label="Período Inicial"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioNfce.periodo_inicial"
                :rules="rules.perido_inicial_relatorio_nfce"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Período Final"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosRelatorioNfce.periodo_final"
                :rules="rules.perido_final_relatorio_nfce"
                outlined
                dense
                append-outer-icon="print"
                @click:append-outer="_gerarRelatorioNfce()"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>
    <v-card outlined class="mt-2">
      <v-card-title>Exportar XML.</v-card-title>
      <v-form class="px-3" ref="formExportarXml">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md4>
              <v-text-field
                label="Período Inicial"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosExportacaoXml.periodo_inicial"
                :rules="rules.perido_final_exportarcao_xml"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="Período Final"
                type="date"
                class="mr-2 ml-2"
                v-model="dadosExportacaoXml.periodo_final"
                :rules="rules.perido_final_exportarcao_xml"
                outlined
                dense
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                label="E-mail"
                class="mr-2 ml-2"
                v-model="dadosExportacaoXml.email"
                :rules="rules.email_exportarcao_xml"
                outlined
                dense
                append-outer-icon="print"
                @click:append-outer="_exportarXmlNfe()"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>
  </LayoutDashboard>
</template>
<script>
import { mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      dadosRelatorioNfe: {
        periodo_inicial: moment().format("YYYY-MM-DD"),
        periodo_final: moment().format("YYYY-MM-DD"),
      },
      dadosRelatorioNfce: {
        periodo_inicial: moment().format("YYYY-MM-DD"),
        periodo_final: moment().format("YYYY-MM-DD"),
      },
      dadosExportacaoXml: {
        periodo_inicial: moment().format("YYYY-MM-DD"),
        periodo_final: moment().format("YYYY-MM-DD"),
        email: "",
      },
      rules: {
        perido_inicial_relatorio_nfe: [(v) => !!v || "Campo obrigatório"],
        perido_final_relatorio_nfe: [(v) => !!v || "Campo obrigatório"],
        perido_inicial_relatorio_nfce: [(v) => !!v || "Campo obrigatório"],
        perido_final_relatorio_nfce: [(v) => !!v || "Campo obrigatório"],
        perido_final_exportarcao_xml: [(v) => !!v || "Campo obrigatório"],
        perido_final_exportarcao_xml: [(v) => !!v || "Campo obrigatório"],
        email_exportarcao_xml: [(v) => !!v || "Campo obrigatório"],
      },
    };
  },
  methods: {
    ...mapActions([
      "exportarXmlNfe",
      "gerarRelatorioNfe",
      "gerarRelatorioNfce",
    ]),

    _gerarRelatorioNfe() {
      if (this.$refs.formRelatorioNfe.validate()) {
        this.gerarRelatorioNfe(this.dadosRelatorioNfe);
      }
    },
    _gerarRelatorioNfce() {
      if (this.$refs.formRelatorioNfce.validate()) {
        this.gerarRelatorioNfce(this.dadosRelatorioNfce);
      }
    },
    _exportarXmlNfe() {
      if (this.$refs.formExportarXml.validate()) {
        this.exportarXmlNfe(this.dadosExportacaoXml);
      }
    },
  },
};
</script>
